<template>
  <footer class="flex page-footer justify-between text-sm c-slate-500">
    <span>{{ $t('footer.hint') }}</span>
    <span>{{ $t('footer.rights', { year }) }}</span>
  </footer>
</template>

<script setup>
const year = new Date().getFullYear()
</script>
